<template>
    <DropdownV2
        class=""
        :menuSpace="8"
        forceSide="right"
        @dropdown="
            (open) => {
                showExtend = showExtend && open ? false : showExtend
            }
        "
    >
        <template #button>
            <IconAdditionalSettings class="h-5 w-5 fill-grey-800 stroke-grey-800 hover:fill-grey-900 hover:fill-grey-900 shrink-0" />
        </template>
        <template #menu>
            <div class="table-multi-select-menu bg-black min-w-[284px]">
                <p class="text-grey-800 text-14 pb-1.5 px-4 pt-0.5">{{ $help.capitalizeFirstLetter(data.appointment == 1 ? 'event' : 'task') }} options</p>
                <template v-if="!showExtend">
                    <button data-close @click="data.view()">View {{ data.appointment == 1 ? 'event' : 'task' }}</button>
                    <NuxtLink :to="data.calendarLink()">View calendar</NuxtLink>
                    <button data-close @click="data.edit()">Edit {{ data.appointment == 1 ? 'event' : 'task' }}</button>
                    <button data-close @click="data.complete()" v-if="data.statusString() != 'Completed' && data.statusString() != 'Done' && data.statusString() != 'Cancelled'">
                        {{ data.appointment == 1 ? 'Cancel event' : 'Mark as done' }}
                    </button>
                    <button data-close @click="data.clearComplete()" v-else>{{ data.appointment == 1 ? 'Undo cancel' : 'Undo done' }}</button>
                    <button @click="showExtend = true" class="flex items-center justify-between" v-if="data.appointment == 0">
                        <p>Extend {{ data.appointment == 1 ? 'event' : 'task' }}</p>
                        <IconArrowRight class="h-4.5 w-4.5 stroke-white" />
                    </button>
                    <button data-close @click="data.destroy()">Delete {{ data.appointment == 1 ? 'event' : 'task' }}</button>
                </template>

                <template v-else>
                    <button class="flex items-center !pl-3" @click.stop="showExtend = false">
                        <IconArrowLeft class="h-5 w-5 stroke-grey-800" />
                        <p class="text-grey-800 text-14">Back</p>
                    </button>
                    <button data-close @click="data.extend('1 day')">Move to tomorrow at 9am</button>
                    <button data-close @click="data.extend('1 week')">Move to next Monday at 9am</button>
                    <button data-close @click="data.extend('1 month')">
                        Move to the 1st
                        {{ this.$help.capitalizeFirstLetter(this.$moment().add(1, 'months').format('MMMM')) }} at 9am
                    </button>
                </template>
            </div>
        </template>
    </DropdownV2>
</template>

<script>
export default {
    props: {
        data: Object,
    },

    data() {
        return {
            showExtend: false,
        }
    },
}
</script>
